import * as Sentry from '@sentry/node';
import { Dedupe, ExtraErrorData } from '@sentry/integrations';
import { ConnectivityError } from 'app/vendor/heydoctor';
import { isHttp4XXError, isServer } from 'app/lib/utils';
import { IncomingMessage } from 'http';

const environment = process.env.STAGE || 'dev';
const dsn = process.env.SENTRY_DSN;
const release = process.env.SENTRY_RELEASE;

export const sentryInit = () =>
  Sentry.init({
    enabled: environment !== 'dev',
    environment,
    dsn,
    release,
    integrations: [new Dedupe(), new ExtraErrorData()],
    ignoreErrors: [/IntersectionObserver/, /EVENT_TAGS_VALIDATOR/],
    beforeSend: (event, hint) => {
      if (!hint) {
        // return null;
      }

      if (hint?.originalException instanceof ConnectivityError) {
        return null;
      }

      if (event.exception && event.exception.values && event.exception.values.length === 1) {
        const msg = event.exception.values[0].value;
        if (msg && isHttp4XXError(msg)) {
          // return null;
        }
      }

      return event;
    },
  });

// Scope configured by default, subsequent calls to "configureScope" will add additional data
Sentry.configureScope((scope) => {
  scope.setTag('runtimeEngine', isServer() ? 'server' : 'browser');
  scope.setTag('client', process.env.CLIENT as string);
});

// Configure the Sentry scope by extracting useful tags and context from the given request
export const configureReq = (req: IncomingMessage): void => {
  Sentry.configureScope((scope) => {
    scope.setTag('host', req.headers.host as string);
    scope.setTag('url', req.url as string);
    scope.setTag('method', req.method as string);
    scope.setTag('statusCode', (req.statusCode as unknown) as string);
  });
};

// See https://docs.sentry.io/enriching-error-data/breadcrumbs
export const addBreadcrumb = (url: Location): void => {
  Sentry.addBreadcrumb({
    category: 'url change',
    message: url.toString(),
    level: Sentry.Severity.Debug,
  });
};
